<div class="mif-login">
  @if (showOtpCheck) {
    <app-otp-check [prefilledUserId]="userId" [prefilledSessionId]="sessionId" [showCancel]="false" [centerSubmitButton]="true"></app-otp-check>
  }

  @if (otpRequestFailed) {
    <p class="mif-login-message">Impossible d'envoyer le code de verification.</p>
  }
</div>